var scrollTop = function () {
  let $body = $(document.body);
  let _SCROLL_FIXED_CUTOFF;
  let _HEADER_HEIGHT;
  _SCROLL_FIXED_CUTOFF = _SCROLL_FIXED_CUTOFF || ($(window).height() >= 825 ? 300 : 75),
    _HEADER_HEIGHT = _HEADER_HEIGHT || 825;

  $(window).scroll(function (e) {

    if ($('nav.top[data-no-scroll]').length)
      return;

    if (this.pageYOffset >= _SCROLL_FIXED_CUTOFF && !$body.hasClass('scrolled')) {
      $body.addClass('scrolled');
    } else if (this.pageYOffset < _SCROLL_FIXED_CUTOFF && $body.hasClass('scrolled')) {
      $body.removeClass('scrolled');
    }

    if (this.pageYOffset >= _HEADER_HEIGHT) {
      _header_carousel_active = false;
    } else {
      _header_carousel_active = true;
    }

  });
}

$(function () {

  let body = document.body;
  let pageHeight = body.scrollHeight;
  let sbHeight = 5 * window.innerHeight * (window.innerHeight / document.body.scrollHeight);
  let footerOffset = pageHeight - 150;
  let chatWidget = $(".zsiq_theme1.zsiq_floatmain");

  $(window).scroll(function (e) {
    pageOffsetY = this.pageYOffset;
    pageOffsetTop = pageOffsetY + sbHeight;
    if (pageOffsetTop > footerOffset) {
      chatWidget.addClass("fixed");
    } else if (pageOffsetTop <= footerOffset) {
      chatWidget.removeClass("fixed");
    }

  });

});

var underlineText = function () {
  let titleEle = $(".cs-underline");
  let titleText = titleEle.text();
  let titleHTML = '<span class="caspersmile-highlighted-text-wrapper">'
  titleHTML += '<span class="caspersmile-highlighted-text">' + titleText + '</span>'
  titleHTML += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 249 9" preserveAspectRatio="none"><path d="M1.90909 6.48431C47.7151 2.98311 160.866 -1.81245 247.023 7.01492"></path></svg>'
  titleHTML += '</span>';

  titleEle.html(titleHTML);
}

var onLoadShowAllTabs = function () {
  if (typeof ($(".nav-filters")) != "undefined") {
    $(".nav-filters a:first").trigger("click");
  }
}
var onClickShowAllTAbs = function () {
  $(".nav-filters").on("click", "a", function () {
    let sectionID = $(this).attr("href");
    let $tabContentBlocks = $("#toggle-views > div ");

    if (sectionID == "#view-all") {
      $tabContentBlocks.addClass("active-all");
    } else {
      $tabContentBlocks.removeClass("active-all");
    }

  });
}

var mobileSliders = [];
var isMobile = false;
var checkIsMobile = function () {
  let isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
  return isMobile;
}
var setMobileSliders = function (isMobile = false) {
  let mobileSlider = [];
  if (isMobile) {

    $(".mobile-slider").each(function (i, e) {
      mobileSlider[i] = new Flickity(e, {
        draggable: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,

      })
    });

  }
  return mobileSlider;
}
$(function () {
  $(".btn-toggle-plans").on("click", function (event) {
    event.preventDefault();
    let $btn = $(this)
    let $activeId = $($btn.attr("href"));
    $("#all-day-caspersmile .package-block, #nightlong-caspersmile .package-block").addClass("hide");
    $activeId.find(".package-block").removeClass("hide");
    $(".btn-toggle-plans").parent("li").removeClass("active");
    $btn.parent("li").addClass("active");
  })


  $resultSlider = $(".flick-carousel").flickity({ pageDots: false, wrapAround: true, prevNextButtons: false });
  $(".carousel-btn.next").on("click", function () {
    $resultSlider.flickity("next");
  })
  $(".carousel-btn.previous").on("click", function () {
    $resultSlider.flickity("previous", true);
  })

});
var getUrlVars = function () {
  let vars = [], hash;
  let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    //   vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

var animateToPlans = function (positionTop) {

  $('html, body').animate({
    scrollTop: (positionTop)
  }, 1000);

}

var switchToActivePlan = function (params) {
  $sectionPosition = $(".section.pricing").last().offset();
  if (typeof ($sectionPosition) != "undefined") {

    $positionTop = $sectionPosition.top - 70;

    if (typeof (params['switch']) != 'undefined'
      && params['switch'] == 'plan'
      && typeof (params['plan']) != 'undefined'
      && params['plan'] == 'nightlong') {

      $(".toggle-plans-filters  a#night-caspersmile").each(function (i, e) {
        $(this).trigger("click");
      });
      animateToPlans($positionTop);
    }
    if (typeof (params['switch']) != 'undefined' && params['switch'] == 'plan' && typeof (params['plan']) != 'undefined' && params['plan'] == 'all-day') {
      animateToPlans($positionTop);
    }
  }
}

var slideUpAssessment = function (ele) {
  $ele = $(this);
  $("#am-i-candidate .quiz-welcome-section").hide();
  $("#am-i-candidate .quiz-form").show();
}

var btnPrimaryAnimate = function () {

  let $btns = $(".btn-primary");
  $btns.each((i, e) => {
    $(e).append("<span></span>");
  });
  $btns.on("mouseenter mouseout", function (event) {
    let $btn = $(this);
    let $span = $btn.find("span");
    let parentOffset = $btn.get(0).getBoundingClientRect();
    let scrollPosition = $(window).scrollTop();
    relX = event.pageX - parentOffset.left,
      relY = event.pageY - (parentOffset.top + scrollPosition);
    $span.css("top", (relY + "px"));
    $span.css("left", (relX + "px"));

  });

}




var CsBannerAnimate = function (obj = "banner-images") {
  let images = [].slice.call($(obj));

  this.start = function () {
    preLoadImages(images);
    imageSwitch(images);
  }

  let preLoadImages = function ($img, src) {
    for (let i = 0; i < images.length; i++) {
      let $img = $(images[i]);
      let src = $img.data("src");

      if (typeof ($img.attr("src")) == "undefined") {
        $img.attr("src", src)
      }
      delay(500);
    }
  }

  let delay = function (time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  let imageSwitch = async function (images) {
    for (let i = 0; i < images.length; i++) {
      let $img = $(images[i]);
      let src = $img.data("src");
      let delayTime = $img.data("delay-load");
      let $container = $img.parent('div');
      await delay(delayTime);
      $container.find("img").addClass("hide")
      $img.removeClass("hide")
    }

  }
}

"use_strict";
$(function () {
  let isMobile = checkIsMobile();
  let upperSlide = new resultSlider('.slider-rtl');
  let lowerSlide = new resultSlider('.slider-ltr', null, 1.3, 'ltr');
  let mobileSliders = setMobileSliders(isMobile);
  let current_url_params = getUrlVars();
  let csBannerAnimation = new CsBannerAnimate(".animation-images img");

  underlineText();
  scrollTop();
  btnPrimaryAnimate();
  onClickShowAllTAbs();
  onLoadShowAllTabs();
  csBannerAnimation.start();
  switchToActivePlan(current_url_params);

})

$(function () {

  if ($(".main-navbar>ul>li").hasClass("active")) {
    $(".selected").addClass("selected");
    var currentleft = $(".active").position().left + "px";
    var currentwidth = $(".active").css("width");
    $(".nav-ghost").css({ left: currentleft, width: currentwidth });
  }
  $(".main-navbar>ul>li").hover(
    function () {
      let $currElement = $(this);
      $(".main-navbar > ul >li").removeClass("selected");
      $currElement.addClass("selected");
      var currentleft = $currElement.position().left + "px";
      var currentwidth = $currElement.css("width");
      $(".nav-ghost").css({ left: currentleft, width: currentwidth });
    },
    function () {
      let $currElement = $(this);
      if ($(".main-navbar>ul>li").hasClass("active")) {
        $(".active").addClass("selected");
        var currentleft = $(".active").position().left + "px";
        var currentwidth = $(".active").css("width");
        $(".nav-ghost").css({ left: currentleft, width: currentwidth });
      } else {
        var currentleft = $currElement.position().left + "px";
        var currentwidth = $currElement.css("width");
        $(".nav-ghost").css({ left: currentleft, width: currentwidth });
      }
    }
  );
});
"use_strict";
$(function () {
  $("#day-caspersmile>a.btn-toggle-plans").on("click", () => {
    $(".all-day-caspersmile .package-blocks").removeClass("hide");
    $(".nightlong-caspersmile .package-blocks").addClass("hide");
  })

  $("a#night-caspersmile.btn-toggle-plans").on("click", () => {
    $(".all-day-caspersmile .package-blocks").addClass("hide");
    $(".nightlong-caspersmile .package-blocks").removeClass("hide");
  })
})
"use_strict";
$(function () {

  $(".package-block").on("click", ".payment-info", function (e) {
    console.log($(this).html());
    let isOpen = $(this).hasClass("open");
    if (!isOpen) {
      $(".package-block .payment-info").removeClass("open");
      $(this).addClass("open");
    } else {
      $(".package-block .payment-info").removeClass("open");
    }

  });

  $(".collapse-payment-plan").on("click", ".btncollapse", function (e) {

    e.preventDefault();

    let btn = $(this);
    let card = btn.parents(".card");
    let targetEle = $(this).data("target");
    let plan = $(this).data("plan");
    let $target = $(targetEle);

    if (!$target.hasClass("in")) {
      $(".collapse-payment-plan .collapse").removeClass("in");
      $target.addClass("in");
    }

    if (btn.hasClass("collapsed")) {
      $(".card").addClass("collapsed");
      card.removeClass("collapsed");
    }

    if (btn.hasClass("collapsed")) {
      $(".btn.btncollapse").addClass("collapsed");
      btn.removeClass("collapsed");
    }

    if (plan == "partially") {
      $(".pay-with-partially").removeClass("hide");
      $(".add-to-cart").addClass("hide");
    } else {

      $(".pay-with-partially").addClass("hide");
      $(".add-to-cart").removeClass("hide");
    }

    return false;

  });

  $(".collapse-payment-plan").on("click", ".payment-card-select", function (e) {

    // e.preventDefault();


    let plan = $(this).data("plan");

    if (plan == "partially") {
      $(".pay-with-partially").removeClass("hide");
      $(".add-to-cart").addClass("hide");
    } else {

      $(".pay-with-partially").addClass("hide");
      $(".add-to-cart").removeClass("hide");
    }

    // return false;

  })

});
"use_strict";
$(function () {
  $(".arch-buttons").on("click", ".btn", function () {

    let val = $(this).find("input").val();
    let id = $(this).find("input").attr("id");
    $("select#treatable-arch").val(val);

  });

});

"use strict";
$(() => {
  $(".plan-buttons").on("click", ".btn", function () {
    let $errorNote = $(".plan-buttons .error");
    let $ele = $(this);
    let $checkbox = $ele.find("input[type='checkbox']");
    let $checkboxName = $checkbox.prop("name");
    let variantField = $("input[name='properties[Arch]']");
    let variantVal = "";

    $(".plan-buttons .btn").removeClass("active");
    $(".plan-buttons input[type='checkbox']").prop("checked", false);

    $ele.addClass("active");
    $checkbox.prop("checked", true);

    let selectedValue = $checkboxName === "upper_arch" ? "Upper" : "Lower";
    variantVal = selectedValue;

    variantField.val(variantVal);

    $errorNote.css("display", "none");
    $("#one-time-payment-button").prop("disabled", false);
  });
});



"use_strict";
$(() => {

  var selectedPlan = { "all_day": true, "nightlong": false }
  $(".btn-cs-plans").on("click", ".btn-plan-option", function () {

    selectedPlan = { "all_day": false, "nightlong": false }


    let $btns = $(".btn-cs-plans button");
    let $errorNote = $(".btn-cs-plans .error");
    let $btn = $(this);
    let $btnName = $btn.prop("name");
    let isActive = $btn.data("status");
    let variantField = $("input[name='properties[Plan]']");
    let variantVal = "";

    $btns.each(function () {
      btnStatus = $(this).data('status') == 'active' ? '' : 'active';
      $(this).data('status', btnStatus);
      $(this).removeClass('active');
      $(this).addClass(btnStatus);
    });

    console.log($btn.html(), $btnName);
    if ($btnName == 'all_day') {
      variantVal = 'All-Day Caspersmile';
    } else {
      variantVal = 'Nightlong Caspersmile';
    }

    variantField.val(variantVal);

  })

});
"use_strict";
$(function () {
  $(".product-radio-variants").on("click", "label", function () {
    $(".product-radio-variants label").removeClass('active');
    $(this).addClass('active');
    $(".product-radio-variants input[type=radio]").prop("checked", false);
    $clickedBtn = $(this).find("input[type=radio]");
    $clickedBtn.prop("checked", true);
    let value = $clickedBtn.val();
    $("input[name=id]").val(value);

  })
});

$(function () {
  $(".retainer-variants").on("click", "label", function (e) {
    e.preventDefault();
    $(".retainer-variants label").removeClass('active');
    $(this).addClass('active');
    $(".retainer-variants input[type=radio]").prop("checked", false);
    $clickedBtn = $(this).find("input[type=radio]");
    $clickedBtn.prop("checked", true);
    let $this = $(this);
    let value = $clickedBtn.val();
    let price = $this.data("price");
    let comparePrice = $this.data("compare-price");
    let title = $this.data("title");

    $(".product-description .sets").html(title);
    $("input[name=id]").val(value);
    if (comparePrice != "") {
      $(".payment-plan .payment-plan-price").addClass("with-compare-price");
      $(".payment-plan .previous-price").html("(" + comparePrice + ")");
    } else {
      $(".payment-plan .payment-plan-price").removeClass("with-compare-price");
      $(".payment-plan .previous-price").html("");
    }

    $(".payment-plan .amount").html(price);
    return false;
  })

});


"use_strict";
$(function () {
  $(".product-image-variants").on("click", "label", function () {
    $(".product-image-variants label").removeClass('active');
    $(this).addClass('active');
    $(".product-radio-variants input[type=radio]").prop("checked", false);
    $clickedBtn = $(this).find("input[type=radio]");
    $clickedBtn.prop("checked", true);
    let value = $clickedBtn.val();
    let dataIndex = $(this).data("index");
    let slideIndex = dataIndex - 1;
    $("input[name=id]").val(value);

    $('.slider-nav').slick('slickGoTo', slideIndex);

  })
});
"use_strict";
$(function () {
  $('.image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    fade: false,
    dots: true
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".elite-accordion-box");

  options.forEach(option => {
    option.addEventListener("click", function () {
      options.forEach(opt => {
        opt.classList.remove("active");
      });
      this.classList.add("active");
    });
  });
});

function redirect(url) {
  document.location.href = url;
  return false;
}






document.addEventListener("DOMContentLoaded", function () {
  let blogContent = document.querySelector(".blog-content-container");

  if (blogContent) {
    let headings = blogContent.querySelectorAll("h2");

    headings.forEach((heading) => {
      if (heading.textContent.trim() !== "") {
        let formattedId = heading.textContent.trim().toLowerCase().replace(/\s+/g, "-");
        heading.id = formattedId;
      }
    });
  }
});





$(document).ready(function () {
  $(".panel-title a").click(function () {
    var icon = $(this).find(".icon");
    $(".panel-title .icon").text("+");
    if (!$(this).closest(".panel-heading").next().hasClass("in")) {
      icon.text("-");
    }
  });
});





$(document).ready(function () {
  function initSlick() {
    if ($(window).width() < 768) {
      if (!$('.lists-container-img-desc.partner').hasClass('slick-initialized')) {
        $('.lists-container-img-desc.partner').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: false,
          dots: true 
        });
      }
    } else {
      if ($('.lists-container-img-desc.partner').hasClass('slick-initialized')) {
        $('.lists-container-img-desc.partner').slick('unslick');
      }
    }
  }

  initSlick();

  $(window).on('resize', function () {
    initSlick();
  });
});




// Pengination Doctors Page For Mobile 

$(document).ready(function () {
  function initSlick() {
    if ($(window).width() < 768) {
      if (!$('.flex-slider-block').hasClass('slick-initialized')) {
        $('.flex-slider-block').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: false,
          dots: false,
        });

        $('.flex-slider-block').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $('.step-circle-mbl').removeClass('active');
          $('.step-circle-mbl').eq(nextSlide).addClass('active');
        });

        $('.step-circle-mbl').click(function () {
          var index = $(this).index() / 2;
          $('.flex-slider-block').slick('slickGoTo', index);
        });
      }
    } else {
      if ($('.flex-slider-block').hasClass('slick-initialized')) {
        $('.flex-slider-block').slick('unslick');
      }
    }
  }

  initSlick();

  $(window).on('resize', function () {
    initSlick();
  });
});





// window.onload = function () {
//   $('.card_slider .slider').slick({
//     autoplay: true,
//     autoplaySpeed: 1500,
//     arrows: true,
//     prevArrow: '<button type="button" class="slick-prev">&#10229;</button>',
//     nextArrow: '<button type="button" class="slick-next"> &#x27F6;</button>',
//     // centerMode: true,
//     dots: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         }
//       }
//     ]
//   });
// };




$(document).ready(function () {
  const $slider = $('.videos-slider');
  const $dotsContainer = $('.videos-slider-dots');

  // Generate custom dots based on number of slides
  function generateCustomDots() {
    $dotsContainer.empty(); // clear existing dots
    const slideCount = $slider.find('li').length;

    for (let i = 0; i < slideCount; i++) {
      $dotsContainer.append('<div class="custom-dot" data-slide="' + i + '"></div>');
    }

    $dotsContainer.find('.custom-dot').first().addClass('active');
  }

  generateCustomDots();

  // Initialize Slick
  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 3, // default for desktop
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false, // use custom dots
      responsive: [
        {
          breakpoint: 768, // <768px
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Custom dot clicks
  $dotsContainer.on('click', '.custom-dot', function () {
    const index = $(this).data('slide');
    $slider.slick('slickGoTo', index);
  });

  // Update active dot on slide change
  $slider.on('afterChange', function (event, slick, currentSlide) {
    $dotsContainer.find('.custom-dot').removeClass('active');
    $dotsContainer.find('.custom-dot[data-slide="' + currentSlide + '"]').addClass('active');
  });
});





$(document).ready(function () {
  $('.customer-logos.slider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
});



// document.addEventListener("DOMContentLoaded", function () {

//   $('.product-dual-arch-left .slider-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: false,
//     loop: false,
//     asNavFor: '.slider-nav'
//   });
//   $('.product-dual-arch-left .slider-nav').slick({
//     slidesToShow: 4,
//     slidesToScroll: 5,
//     asNavFor: '.slider-for',
//     dots: false,
//     loop: false,
//     centerMode: false,
//     focusOnSelect: true
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  $('.product-dual-arch-left .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: false,
    asNavFor: '.product-dual-arch-left .slider-nav'
  });

  $('.product-dual-arch-left .slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-dual-arch-left .slider-for',
    dots: false,
    infinite: false,
    focusOnSelect: true
  });

});




document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".product-new-dual-arch");
  const cards = wrapper.querySelectorAll(".payment-card-select");
  const buyButton = document.querySelector("#buy-button");

  cards.forEach(card => {
    card.addEventListener("click", function () {
      cards.forEach(c => c.classList.remove("active"));
      card.classList.add("active");


      const plan = card.getAttribute("data-plan");

      if (plan === "partially") {
        buyButton.textContent = "Start Monthly Plan";
      } else {
        buyButton.textContent = "Buy One-Time";
      }
    });
  });
});




$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 5,
  asNavFor: '.slider-for',
  dots: false,
  centerMode: true,
  focusOnSelect: true
});




document.querySelectorAll('.filter-btn').forEach(button => {
  button.addEventListener('click', () => {
    let category = button.getAttribute('data-category');
    
    document.querySelectorAll('.filter-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    document.querySelectorAll('.pro-card').forEach(product => {
      if (product.classList.contains(category)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
    // Create the modal HTML structure dynamically
    var modalHTML = `
        <div id="myModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content" style="height: 100%; border-radius:20px;">
                    <div class="modal-header" style="border:1px solid #0092ff; padding: 0px; position: absolute; border-radius: 100%; right: 20px; top: 20px; width: 30px;height: 30px; z-index: 1;">
                       <button type="button" style="margin-top: -4px; padding-left: 4px; color: #0092ff; border-radius: 100%; width: 30px;height: 30px; opacity: 1;" class="close" data-dismiss="modal">&times;</button>
                        
                    </div>
                    <div class="modal-body">
                        <iframe id="clinicIframe" src="" width="100%" height="600px" frameborder="0"></iframe>
                    </div>                    
                </div>
            </div>
        </div>
    `;
    // Insert the modal into the body
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // Add event listener to the button that comes immediately after `.flex-btns-clinic`
    var buttons = document.querySelectorAll(".flex-btns-clinic button");
    buttons.forEach(function (button) {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent form submission
            var clinicInput = this.parentElement.querySelector("input[name='properties[Clinic]']");
            var clinicValue = clinicInput ? clinicInput.value : "Not available";
             var iframeUrl = "https://forms.zohopublic.com/CaspersmileUK/form/Scancenterbookingform/formperma/P8o46ufTGwP4u7-VvgWWTz92_loSUP6-ZySnKZC8KZE?clinic=" + encodeURIComponent(clinicValue);

            // Set the iframe source
            document.getElementById("clinicIframe").src = iframeUrl;
            $("#myModal").modal("show"); // Open modal
        });
    });
});



$(function() {
    $('.take-impression-page-slider').slick({
		slidesToShow: 1.4,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function() {
        $('.take-impression-page-slider').slick('resize');
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll(
    ".blog-post-content-main .blog-post-content-all h2, " +
    ".blog-post-content-main .blog-post-content-all h3, " +
    ".blog-post-content-main .blog-post-content-all h4"
  );

  const idMap = {};

  headings.forEach(function (heading) {
    let baseId = heading.textContent.trim().toLowerCase()
      .replace(/[!?]/g, "")
      .replace(/[\s:]+/g, "-");

    let uniqueId = baseId;

    if (idMap[baseId] !== undefined) {
      idMap[baseId]++;
      uniqueId = `${baseId}-${idMap[baseId]}`;
    } else {
      idMap[baseId] = 0;
    }

    heading.id = uniqueId;
  });
});



  document.addEventListener("DOMContentLoaded", function () {
    const copyBtn = document.getElementById("copy-link-blog-post");

    copyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const url = window.location.href;

      navigator.clipboard.writeText(url).then(function () {
        const wrapper = copyBtn.querySelector(".copy-icon-wrapper");
        wrapper.classList.add("show-copied");

        setTimeout(() => {
          wrapper.classList.remove("show-copied");
        }, 2000);
      }).catch(function (err) {
        console.error("Failed to copy URL:", err);
      });
    });
  });



    document.addEventListener("DOMContentLoaded", function () {
    const copyBtnBottom = document.getElementById("copy-link-blog-post-bottom");

    copyBtnBottom.addEventListener("click", function (e) {
      e.preventDefault();
      const url = window.location.href;

      navigator.clipboard.writeText(url).then(function () {
        const wrapper = copyBtnBottom.querySelector(".copy-icon-wrapper");
        wrapper.classList.add("show-copied");

        setTimeout(() => {
          wrapper.classList.remove("show-copied");
        }, 2000);
      }).catch(function (err) {
        console.error("Failed to copy URL:", err);
      });
    });
  });


  
  // Teens Page Cart Drawer Starter

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('custom-cart-drawer');
  if (!drawer) return;

  const overlay = drawer.querySelector('.drawer-close');
  const content = drawer.querySelector('.drawer-content');
  const itemsContainer = drawer.querySelector('.drawer-items');
  const subtotalEl = drawer.querySelector('.subtotal');
  const checkoutBtn = drawer.querySelector('.checkout-btn');
  const bodyEl = document.body;

  function openDrawer() {
    drawer.classList.add('open');
    bodyEl.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    bodyEl.classList.remove('cart-drawer-open');
  }

  overlay.addEventListener('click', closeDrawer);
  content.addEventListener('click', e => e.stopPropagation());

  // Close drawer if click happens outside
  document.addEventListener('click', function (e) {
    if (
      drawer.classList.contains('open') &&
      !content.contains(e.target) // clicked outside drawer content
    ) {
      closeDrawer();
    }
  });

  function renderDrawerAndBadge(cart) {
    window.cartIcon = 'https://cdn.shopify.com/s/files/1/0836/8517/9710/files/teens-cart-drawer-icon.png?v=1756795883';

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div class="empty-cart-message">
          <img src="${window.cartIcon}" alt="Cart" class="img-responsive">
          <p>Your cart is empty</p>
        </div>`;
      subtotalEl.style.display = 'none';
      checkoutBtn.style.display = 'none';
    } else {
      const itemsHtml = cart.items.map((item, idx) => `
        <div class="cart-item" data-line="${idx + 1}">
          <img src="${item.image}" alt="${item.product_title}">
          <div class="item-info">
            <p>${item.product_title}</p>
            <span>${item.quantity} × £${(item.line_price / 100).toFixed(2)}</span>
          </div>
          <button class="item-remove" data-line="${idx + 1}"></button>
        </div>`).join('');
      itemsContainer.innerHTML = itemsHtml;
      subtotalEl.textContent = '£' + (cart.total_price / 100).toFixed(2);
      subtotalEl.style.display = '';
      checkoutBtn.style.display = '';
    }

    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.textContent = cart.item_count > 0 ? cart.item_count : '';
  }

  function refreshCart(openAfter = true) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderDrawerAndBadge(cart);
        if (openAfter) openDrawer();
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  document.querySelectorAll('.slider-add-to-cart, .your-other-add-to-cart-selector').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.dataset.variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => refreshCart(true))
      .catch(err => console.error('Add to Cart Error:', err));
    });
  });

  itemsContainer.addEventListener('click', function (e) {
    if (e.target.matches('.item-remove')) {
      e.stopPropagation();
      const line = parseInt(e.target.dataset.line);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      })
      .then(res => res.json())
      .then(() => refreshCart(false))
      .catch(err => console.error('Remove Error:', err));
    }
  });

  refreshCart(false);
});

  // Teens page cart drawer Ender 



  // Retainer Benifits Slider 










    $(function() {
    $('.mobile-slider-retainer-how-order').slick({
		slidesToShow: 1.4,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function() {
        $('.mobile-slider-retainer-how-order').slick('resize');
    });
});



// Mouth Guard Blog Sec Slider 

  $(document).ready(function () {
  $('.blog-mouth-guard-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});




      // MouthGuard Benifits Slider 

  $(document).ready(function () {
  $('.mouth-guard-benifits-slider').slick({
    slidesToShow: 4,
    variableWidth: true,
    autoplaySpeed: 0,
    slidesToScroll: 1,
    speed: 3000,
    autoplay: true,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

      // NightGuard Benifits Slider 

  $(document).ready(function () {
  $('.night-guard-benifits-slider').slick({
    slidesToShow: 4,
    variableWidth: true,
    autoplaySpeed: 0,
    slidesToScroll: 1,
    speed: 3000,
    autoplay: true,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});



// Stories Modals 

document.addEventListener("DOMContentLoaded", function () {
  const storyButtons = document.querySelectorAll(".story-btn");

  storyButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      storyButtons.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");

      const targetModal = document.querySelector(this.getAttribute("data-target"));
      if (targetModal) {

        targetModal.addEventListener("hidden.bs.modal", function () {
          storyButtons.forEach((b) => b.classList.remove("active"));
        });
      }
    });

    btn.addEventListener("mouseenter", function () {
      storyButtons.forEach((b) => {
        if (b !== this) {
          b.classList.remove("active");
        }
      });
    });
  });
});





  window.addEventListener('DOMContentLoaded', () => {
  const iframe = document.querySelector('iframe .assessment-form');
  console.log(iframe, "iframe test")
  if (iframe) {
    iframe.onload = () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDoc) {
        const elements = iframeDoc.querySelectorAll('.zfImgChoiceWrapper .imgChoiceDiv');
        elements.forEach(el => {
          el.style.padding = '20px 16px';
        });
      }
    };
  } else {
    console.warn('Iframe with class "assessment-form" not found.');
  }
});




// Plans Affirm Tooltop

document.addEventListener('DOMContentLoaded', function () {
  // Select all tooltip buttons and their boxes
  const tooltipButtons = document.querySelectorAll('.shopPayTooltipBtn');
  const tooltipBoxes = document.querySelectorAll('.shopPayTooltipBox');

  // Function to toggle tooltip visibility
  function toggleTooltip(btn, box, e) {
    e.stopPropagation();

    // Hide all tooltips first
    tooltipBoxes.forEach(b => b.classList.remove('show'));

    // Show or toggle the clicked one
    box.classList.toggle('show');
  }

  // Hide tooltips when clicking outside
  function hideAllTooltips(e) {
    let clickedInside = false;

    tooltipButtons.forEach((btn, i) => {
      const box = tooltipBoxes[i];
      if (btn.contains(e.target) || box.contains(e.target)) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      tooltipBoxes.forEach(b => b.classList.remove('show'));
    }
  }

  // Attach listeners for each tooltip button
  ['click'].forEach(evt => {
    tooltipButtons.forEach((btn, i) => {
      const box = tooltipBoxes[i];
      if (btn && box) {
        btn.addEventListener(evt, e => toggleTooltip(btn, box, e));
      }
    });

    // Hide tooltips when clicking/tapping outside
    document.addEventListener(evt, hideAllTooltips);
  });
});


// Blog Retainer Dynamic Price 

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".retainers-cut-price").forEach(function(el) {
    el.innerHTML = "£125";
  });
});


// Blog All-Day Dynamic Price 

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".all-day-price").forEach(function(el) {
    el.innerHTML = "£675";
  });
});



